module.exports = __webpack_public_path__ + "static/media/tutorialArrow2.1ba80311.svg";